import { SearchOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, Form, Input, Radio, Row, Select, Space, Typography } from 'antd';
import ja_JP from 'antd/lib/date-picker/locale/ja_JP';
import moment from 'moment';
import {
  forwardRef,
  ForwardRefRenderFunction,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react';
import { useHistory } from 'react-router-dom';
import { convertMomentToStr } from '../../common/compornents/ConvertUtil';
import JuchuShokaiTable from '../../common/compornents/layout/table/JuchuShokaiTable';
import {
  notificationError,
  notificationInfo,
  notificationSuccess,
} from '../../common/compornents/notification';
import { JuchuShokaiSearchInfo } from '../../common/compornents/SearchInfo';
import { Const } from '../../common/constants/Constants';
import { Message } from '../../common/constants/Message';
import { JuchuShokaiSearchType } from '../../common/objectType/JuchuShokaiSearchType';
import { generateMessage } from '../../common/util/MessageUtil';
import ColorSearch from '../../pages/color/ColorSearch';
import NonyusakiSearch from '../../pages/nonyusakiSearch/NonyusakiSearch';
import ProductSearch from '../../pages/seihin/ProductSearch';
import TokuisakiSearch from '../../pages/tokuisaki/CustomerSearch';
import JuchuShokaiServ from '../../services/JuchuShokaiServ';

const { RangePicker } = DatePicker;
const { Option } = Select;
export interface IHandles {
  clickClear: () => void;
}
interface IProps {
  yobidashimotoKbn: string;
  CloseJuchuShokaiModal?: () => void;
  loading?: boolean;
  changeLoading?: (data: any) => void;
}

const JuchuShokai: ForwardRefRenderFunction<IHandles, IProps> = (props: IProps, ref) => {
  const history = useHistory();

  // 検索条件
  let juchuShokaiSearchInfo: JuchuShokaiSearchType = JuchuShokaiSearchInfo();

  // セッション情報
  const [tokCd, setTokCd] = useState<string>('');
  const [tokCd2, setTokCd2] = useState<string>('');
  const companyName = sessionStorage.getItem(Const.LOCAL_STORAGE_VALUE.COMPANY_NAME) ?? '';
  const manager = sessionStorage.getItem(Const.LOCAL_STORAGE_VALUE.TANTO_NAME) ?? '';

  const [tokNm, setTokNm] = useState('');
  const [tok, setTok] = useState<string[]>([]);
  const [productCd, setProductCd] = useState<string>('');
  const [nonyuSaki, setNonyuSaki] = useState<number>();
  const [iroInfo, setIroInfo] = useState<string[]>([]);

  const [form] = Form.useForm();
  const [visibleCustomer, setVisibleCustomer] = useState(false);
  const [visibleNonyu, setVisibleNonyu] = useState(false);
  const [visibleProduct, setVisibleProduct] = useState(false);
  const [visibleColor, setVisibleColor] = useState(false);
  const [visibleBtConf, setVisibleBtConf] = useState(false);
  const [ktnList, setKtnList] = useState<any[]>([]);
  const [searchList, setSearchList] = useState<any[]>([]);
  const [retentionDataList, setRetentionDataList] = useState<any[]>([]);
  const [mCodeKaitoStatusList, setMCodeKaitoStatusList] = useState<any[]>([]);
  // 納入先コンボボックスソース
  const [nonyusakiDataList, setNonyusakiDataList] = useState<any[]>([]);
  const [rIdx, changeRowIndex] = useState(-1);
  const [toklabel, setTokLabel] = useState(<label>お得意先様：</label>);
  const linkLabelTokuisaki = () => {
    return (
      <Typography.Link onClick={() => setVisibleCustomer((prevState) => !prevState)}>
        お得意先様：
      </Typography.Link>
    );
  };

  /**
   * 初期表示
   */
  useEffect(() => {
    // セッションストレージからログインIDの取得
    form.setFieldsValue({
      companyName: companyName,
      manager: manager,
    });

    if (props.yobidashimotoKbn === '1') {
      // 受注入力画面から戻った時
      if (juchuShokaiSearchInfo.execute === '1') {
        let tokCd: string = sessionStorage.getItem(Const.LOCAL_STORAGE_VALUE.TOKUISAKI_CD) || '';
        let tokCd2: string = sessionStorage.getItem(Const.LOCAL_STORAGE_VALUE.TOKUISAKI_CD2) || '';

        if (tokCd !== '' && tokCd2 !== '') {
          setNonyuskiList(tokCd, tokCd2);
          setTok([tokCd, tokCd2]);
        }

        form.setFieldsValue({
          tokCd: juchuShokaiSearchInfo.tokCd,
          tokCd2: juchuShokaiSearchInfo.tokCd2,
          nokiKaito: Number(juchuShokaiSearchInfo.nokiKaito) || 1,
          dateFromTo: [
            checkDateData(juchuShokaiSearchInfo.dateFrom)
              ? moment(juchuShokaiSearchInfo.dateFrom)
              : '',
            checkDateData(juchuShokaiSearchInfo.dateTo) ? moment(juchuShokaiSearchInfo.dateTo) : '',
          ],
          orderNo: juchuShokaiSearchInfo.orderNo !== '' ? juchuShokaiSearchInfo.orderNo : '',
          shipStatus: Number(juchuShokaiSearchInfo.shipStatus) || 1,
          nouCd: juchuShokaiSearchInfo.nouCd !== '' ? Number(juchuShokaiSearchInfo.nouCd) : '',
          productCd: juchuShokaiSearchInfo.productCd !== '' ? juchuShokaiSearchInfo.productCd : '',
          productNm: juchuShokaiSearchInfo.productNm !== '' ? juchuShokaiSearchInfo.productNm : '',
          color: juchuShokaiSearchInfo.color !== '' ? juchuShokaiSearchInfo.color : '',
          prductHub: juchuShokaiSearchInfo.prductHub !== '' ? juchuShokaiSearchInfo.prductHub : '',
        });
        // 検索
        clickBtSearch();
        sessionStorage.setItem(Const.JUCHU_SHOKAI_SEARCH_INFO.EXECUTE, '0');
      }

      // お得意先様ラベルをリンクに変更
      setTokLabel(linkLabelTokuisaki);
      setVisibleBtConf(true);
    } else {
      // 得意先コード設定
      let shokiTok = [];
      shokiTok.push(sessionStorage.getItem(Const.LOCAL_STORAGE_VALUE.TOKUISAKI_CD) ?? '');
      shokiTok.push(sessionStorage.getItem(Const.LOCAL_STORAGE_VALUE.TOKUISAKI_CD2) ?? '');
      setTok(shokiTok);
      setVisibleBtConf(false);
    }

    // 生産拠点の設定
    setProdctHubList();

    // コードマスタの取得
    getMCode();

    // 初期処理のため指定しない
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * useStateの得意先コード（tokCd,tokCd2）が設定された際に得意先名を取得
   */
  useEffect(() => {
    if (tokCd !== '' && tokCd2 !== '') {
      // 得意先名取得
      JuchuShokaiServ.getTokName(tokCd, tokCd2)
        .then((json) => {
          // 画面項目にセット
          form.setFieldsValue({
            tokNm: json.data['nam'],
          });
          setTokNm(json.data['nam']);
        })
        .catch((error) => {
          notificationError(
            '注文一覧',
            generateMessage(Message.ERROR_MASSAGE.ERR999, '得意先名検索')
          );
        });
      //納入先の設定
      setNonyuskiList(tokCd, tokCd2);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tokCd, tokCd2]);

  // 得意先ポップから遷移
  useEffect(() => {
    if (tok.length > 0) {
      // 画面項目にセット
      form.setFieldsValue({
        tokCd: tok[0],
        tokCd2: tok[1],
        tokNm: tok[2],
      });
      setTokCd(tok[0]);
      setTokCd2(tok[1]);

      //納入先の設定
      setNonyuskiList(tok[0], tok[1]);

      // セッション情報の設定
      sessionStorage.setItem(Const.LOCAL_STORAGE_VALUE.TOKUISAKI_CD, tok[0]);
      sessionStorage.setItem(Const.LOCAL_STORAGE_VALUE.TOKUISAKI_CD2, tok[1]);
    }

    // 得意先検索マスタからのデータ取得の際の処理のためtokのみ指定する
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tok]);

  /**
   * 納入先の取得、設定
   */
  const setNonyuskiList = async (tokCd: string, tokCd2: string) => {
    await JuchuShokaiServ.getNonyusakiList(tokCd, tokCd2)
      .then(async (json) => {
        setNonyusakiDataList(() => json.data);
      })
      .catch((error) => {
        notificationError('注文一覧', generateMessage(Message.ERROR_MASSAGE.ERR999, '納入先検索'));
      });
  };

  // 納入先ポップから遷移
  useEffect(() => {
    if (nonyuSaki !== undefined) {
      form.setFieldsValue({
        nouCd: nonyuSaki,
      });
    }
    // 納入先CD変更時のみの処理のためnonyuSakiのみ指定する
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nonyuSaki]);

  // 製品ポップから遷移
  useEffect(() => {
    if (
      visibleProduct === false &&
      productCd !== undefined &&
      productCd !== null &&
      productCd !== ''
    ) {
      form.setFieldsValue({
        productCd: productCd,
      });
    }

    // 製品検索画面から取得時のみのみの処理のためproductCdのみ指定する
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productCd]);

  /**
   * 製品名取得
   */
  useEffect(() => {
    if (
      visibleProduct === false &&
      productCd !== undefined &&
      productCd !== null &&
      productCd !== ''
    ) {
      JuchuShokaiServ.getProductName(tokCd, tokCd2, productCd)
        .then((json) => {
          form.setFieldsValue({
            productNm: json.data['hin_nm'],
          });
        })
        .catch((error) => {
          notificationError(
            '注文一覧',
            generateMessage(Message.ERROR_MASSAGE.ERR999, '製品名検索')
          );
        });
    }

    // 製品名取得処理のためproductCdのみ指定する
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productCd]);

  // 色ポップから遷移
  useEffect(() => {
    if (visibleColor === false && iroInfo !== undefined && iroInfo !== null && iroInfo.length > 0) {
      form.setFieldsValue({
        color: iroInfo[2],
      });
    }
    // 色検索画面から取得時のみの処理のためiroInfoのみ指定する
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [iroInfo]);

  /**
   * 生産拠点の取得、設定
   */
  const setProdctHubList = () => {
    JuchuShokaiServ.getProdctHubList()
      .then((json) => {
        setKtnList(() => json.data);
      })
      .catch((error) => {
        notificationError(
          '注文一覧',
          generateMessage(Message.ERROR_MASSAGE.ERR999, '生産拠点検索')
        );
      });
  };

  /**
   * 行ダブルクリック
   */
  useEffect(() => {
    // 受注入力への遷移
    if (rIdx >= 0) {
      sessionStorage.setItem(Const.LOCAL_STORAGE_VALUE.JYU_NO, searchList[rIdx].jyu_no);
      clickBtClear();
      if (props.yobidashimotoKbn === '2') {
        if (props.CloseJuchuShokaiModal !== undefined) {
          sessionStorage.setItem(Const.LOCAL_STORAGE_VALUE.MOVE_KBN, '1');
          props.CloseJuchuShokaiModal();
          changeRowIndex(-1);
        }
      } else {
        sessionStorage.setItem(Const.JUCHU_SHOKAI_SEARCH_INFO.EXECUTE, '1');
        history.push({ pathname: '/juchu-nyuryoku' });
        changeRowIndex(-1);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rIdx]);

  /**
   * 共通コードマスタの取得
   */
  const getMCode = () => {
    JuchuShokaiServ.getMCodeList(Const.MCODE_KBN_CODE.KAITO_STATUS_CODE)
      .then((json) => {
        setMCodeKaitoStatusList(() => json.data);
      })
      .catch((error) => {
        notificationError(
          '注文一覧',
          generateMessage(Message.ERROR_MASSAGE.ERR999, '共通コード（回答状況）検索')
        );
      });
  };

  /**
   * 日付型チェック
   */
  const checkDateData = (data: any) => {
    if (typeof data === 'string' && moment(data).isValid()) {
      return true;
    }
    return false;
  };

  /**
   * 検索処理
   */
  const clickBtSearch = () => {
    var data = form.getFieldsValue();
    var dateFrom = '';
    var dateTo = '';

    // 注文日変換
    if (data.dateFromTo != null && data.dateFromTo !== '') {
      if (data.dateFromTo[0] != null && data.dateFromTo[0] !== '') {
        dateFrom = moment(data.dateFromTo[0]).format('YYYY/MM/DD 00:00:00.000');
      }
      if (data.dateFromTo[1] != null && data.dateFromTo[1] !== '') {
        dateTo = moment(data.dateFromTo[1]).format('YYYY/MM/DD 23:59:59.999');
      }
    }

    // 検索条件セット
    if (
      data.tokCd !== undefined &&
      data.tokCd !== null &&
      data.tokCd !== '' &&
      data.tokCd2 !== undefined &&
      data.tokCd2 !== null &&
      data.tokCd2 !== '' &&
      juchuShokaiSearchInfo.execute === '0'
    ) {
      setSearchInfo(
        data.tokCd,
        data.tokCd2,
        data.nokiKaito,
        dateFrom,
        dateTo,
        data.orderNo || '',
        data.shipStatus,
        data.nouCd || '',
        data.productCd || '',
        data.productNm || '',
        data.color || '',
        data.prductHub || ''
      );
    }

    // API呼び出し
    JuchuShokaiServ.getSearchList(
      data.tokCd,
      data.tokCd2,
      data.nokiKaito,
      dateFrom,
      dateTo,
      data.orderNo,
      data.shipStatus,
      data.nouCd,
      data.productCd,
      data.color,
      data.prductHub
    )
      .then((json) => {
        if (json.data.length >= 1000) {
          notificationInfo('注文一覧', generateMessage(Message.INFO_MASSAGE.INF010));
        }
        setSearchList(() => []);
        setSearchList(json.data);
        setRetentionDataList(json.data);
      })
      .catch((error) => {
        notificationError('注文一覧', generateMessage(Message.ERROR_MASSAGE.ERR999, '注文検索'));
      });
  };

  // 検索条件をセッション情報にセット
  const setSearchInfo = (
    tokCd: string,
    tokCd2: string,
    nokiAns: string,
    orderDateS: string,
    orderDateE: string,
    orderNo: string,
    shipStatus: string,
    nouCd: string,
    product: string,
    productNm: string,
    dispColor: string,
    prodHub: string
  ) => {
    sessionStorage.setItem(Const.JUCHU_SHOKAI_SEARCH_INFO.TOKUISAKI_CD, tokCd);
    sessionStorage.setItem(Const.JUCHU_SHOKAI_SEARCH_INFO.TOKUISAKI_CD2, tokCd2);
    sessionStorage.setItem(Const.JUCHU_SHOKAI_SEARCH_INFO.NOKI_KAITO, nokiAns);
    sessionStorage.setItem(Const.JUCHU_SHOKAI_SEARCH_INFO.DATE_FROM, orderDateS);
    sessionStorage.setItem(Const.JUCHU_SHOKAI_SEARCH_INFO.DATE_TO, orderDateE);
    sessionStorage.setItem(Const.JUCHU_SHOKAI_SEARCH_INFO.ORDER_NO, orderNo);
    sessionStorage.setItem(Const.JUCHU_SHOKAI_SEARCH_INFO.SHIPSTATUS, shipStatus);
    sessionStorage.setItem(Const.JUCHU_SHOKAI_SEARCH_INFO.NOU_CD, nouCd);
    sessionStorage.setItem(Const.JUCHU_SHOKAI_SEARCH_INFO.PRODUCT_CD, product);
    sessionStorage.setItem(Const.JUCHU_SHOKAI_SEARCH_INFO.PRODUCT_NM, productNm);
    sessionStorage.setItem(Const.JUCHU_SHOKAI_SEARCH_INFO.COLOR, dispColor);
    sessionStorage.setItem(Const.JUCHU_SHOKAI_SEARCH_INFO.PRODUCT_HUB, prodHub);
  };

  /**
   * クリアボタン
   */
  const clickBtClear = () => {
    form.resetFields();
    setSearchList(() => []);
    // 画面項目にセット
    form.setFieldsValue({
      tokCd: tokCd,
      tokCd2: tokCd2,
      tokNm: tokNm,
      companyName: companyName,
      manager: manager,
    });
  };

  /**
   * 確定ボタン
   */
  const clickBtConfi = async () => {
    if (props.loading) return;
    if (props.changeLoading) {
      props.changeLoading(true);
    }
    var updateData: any[] = [];
    var compCd = sessionStorage.getItem(Const.LOCAL_STORAGE_VALUE.COMPANY_CD);
    var acconCd = sessionStorage.getItem(Const.LOCAL_STORAGE_VALUE.ACCOUNT_ID);

    for (let index = 0; index < searchList.length; index++) {
      const retentionData = retentionDataList[index];
      const dispData = searchList[index];
      if (JSON.stringify(retentionData) !== JSON.stringify(dispData)) {
        updateData.push({
          jyuNo: dispData['jyu_no'],
          jyugyoNo: dispData['jyugyo_no'],
          kaitoDt:
            dispData['kaito_dt'] != null
              ? new Date(convertMomentToStr(dispData['kaito_dt']))
              : dispData['kaito_dt'],
          kaitoKbn: dispData['kaito_kbn'],
          kaijyoKbn: dispData['kaijyo_kbn'],
          okuriNo: dispData['okuri_no'],
          syukkaDt:
            dispData['syukka_dt'] != null
              ? new Date(convertMomentToStr(dispData['syukka_dt']))
              : dispData['syukka_dt'],
          updCmCd: compCd,
          upAcCd: acconCd,
          updDt: dispData['updDt'],
        });
      }
    }

    if (updateData.length > 0) {
      let result: any;

      // API呼び出し
      result = await JuchuShokaiServ.updJyuchuMei(updateData);

      if (result.data['rsltCd'] === 'ERR016') {
        notificationInfo('注文一覧', Message.INFO_MASSAGE.INF012);
      } else if (result.data['rsltCd'] === 'SUCCESS') {
        notificationSuccess('注文一覧', generateMessage(Message.INFO_MASSAGE.INF006, '注文'));
        clickBtSearch();
      } else if (result.data['rsltCd'] === 'ERR999') {
        notificationError('注文一覧', generateMessage(Message.ERROR_MASSAGE.ERR999, '注文更新'));
      }
    } else {
      notificationInfo('注文一覧', Message.INFO_MASSAGE.INF009);
      clickBtSearch();
    }
    if (props.changeLoading) {
      props.changeLoading(false);
    }
  };

  // 納入先ポップを閉じる
  const closeNonyusakiPop = async () => {
    await setNonyuskiList(tokCd, tokCd2);
    setVisibleNonyu(false);
  };

  // 色検索ポップを閉じる
  const closeIroPop = () => {
    setVisibleColor(false);
  };

  //受注照会ポップを閉じた時に表を消す
  useImperativeHandle(ref, () => ({
    clickClear() {
      clickBtClear();
    },
  }));

  return (
    <>
      {/* 得意先検索 */}
      <TokuisakiSearch
        tok_cd={tokCd}
        tok_cd2={tokCd2}
        yobidashimotoKbn="1"
        val={tok}
        setVal={setTok}
        visible={visibleCustomer}
        setVisible={setVisibleCustomer}
      />
      {/* 納入先検索 */}
      <NonyusakiSearch
        tokCd={tokCd}
        tokCd2={tokCd2}
        visibleState={visibleNonyu}
        closeNonyusakiSearch={closeNonyusakiPop}
        nonyuSaki={nonyuSaki}
        updateNonyusaki={setNonyuSaki}
      />
      {/* 製品検索 */}
      <ProductSearch
        tok_cd={tokCd}
        tok_cd2={tokCd2}
        cd={productCd}
        setCd={setProductCd}
        visible={visibleProduct}
        setVisible={setVisibleProduct}
      />
      {/* 色検索 */}
      <ColorSearch
        visibleState={visibleColor}
        yobidashimotoKbn="2"
        closeColor={closeIroPop}
        returnItem={setIroInfo}
      />
      <Form
        form={form}
        layout="horizontal"
        autoComplete="off"
        style={{ backgroundColor: '#e6f7ff' }}
      >
        {/* お客先様からログインIDまで */}
        <Row
          style={{
            backgroundColor: '#69c0ff',
            height: '50px',
            paddingTop: '8px',
          }}
        >
          <Col offset={1} style={{ paddingTop: '6px' }}>
            {toklabel}
          </Col>
          <Col xl={2} lg={2} md={2} sm={2} xs={2}>
            <Form.Item name={'tokCd'}>
              <Input className="clsReadOnly" readOnly={true} />
            </Form.Item>
          </Col>
          <Col xl={1} xs={2}>
            <Form.Item name={'tokCd2'}>
              <Input className="clsReadOnly" readOnly={true} />
            </Form.Item>
          </Col>
          <Col xxl={5} xl={6} lg={5} md={4} xs={3}>
            <Form.Item name={'tokNm'}>
              <Input className="clsReadOnly" readOnly={true} />
            </Form.Item>
          </Col>
          <Col offset={1} lg={2} xs={3}>
            <Form.Item label="ログインID"></Form.Item>
          </Col>
          <Col xxl={5} xl={6} lg={5} md={4} xs={3}>
            <Form.Item name={'companyName'}>
              <Input className="clsReadOnly" maxLength={20} readOnly={true} />
            </Form.Item>
          </Col>
          <Col xs={3}>
            <Form.Item name={'manager'}>
              <Input className="clsReadOnly" maxLength={10} readOnly={true} />
            </Form.Item>
          </Col>
        </Row>

        {/* 納期回答から注文日まで */}
        <Row style={{ paddingTop: '1vh' }}>
          <Col offset={1} xxl={1} md={2} sm={3} xs={4}>
            <Form.Item label="納期回答"></Form.Item>
          </Col>
          <Col xxl={3} xl={4} lg={5} sm={3} xs={19}>
            <Form.Item name={'nokiKaito'} initialValue={1}>
              <Radio.Group>
                <Radio value={1}>全て</Radio>
                <Radio value={2}>未</Radio>
                <Radio value={3}>済</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
          <Col xxl={1} md={2} sm={3} xs={{ span: 4, offset: 1 }}>
            <Form.Item label="注文番号"></Form.Item>
          </Col>
          <Col xl={2} md={3} sm={4} xs={5}>
            <Form.Item name={'orderNo'}>
              <Input maxLength={10} />
            </Form.Item>
          </Col>
          <Col
            xxl={{ span: 1, offset: 3 }}
            xl={{ span: 2, offset: 3 }}
            md={{ span: 2, offset: 1 }}
            sm={{ span: 3, offset: 9 }}
            xs={{ span: 4, offset: 11 }}
          >
            <Form.Item label="注文日"></Form.Item>
          </Col>
          <Col>
            <Form.Item name={'dateFromTo'}>
              <RangePicker locale={ja_JP} format={'YYYY/MM/DD'} allowEmpty={[true, true]} />
            </Form.Item>
          </Col>
        </Row>

        {/* 出荷状況から製品まで */}
        <Row>
          <Col offset={1} xxl={1} md={2} sm={3} xs={4}>
            <Form.Item label="出荷状況"></Form.Item>
          </Col>
          <Col xxl={3} xl={4} lg={5} sm={3} xs={19}>
            <Form.Item name={'shipStatus'} initialValue={1}>
              <Radio.Group>
                <Radio value={1}>全て</Radio>
                <Radio value={2}>未</Radio>
                <Radio value={3}>済</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
          <Col xxl={1} md={2} sm={3} xs={{ span: 4, offset: 1 }} style={{ paddingTop: '6px' }}>
            <Typography.Link onClick={() => setVisibleNonyu((prevState) => !prevState)}>
              納入先:
            </Typography.Link>
          </Col>
          <Col xl={4} md={3} sm={4} xs={18}>
            <Form.Item name={'nouCd'}>
              <Select allowClear notFoundContent=" ">
                {nonyusakiDataList.map((item, i) => {
                  return (
                    <Option key={i} value={item.nouCd}>
                      {item.nouNm}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col
            offset={1}
            xxl={1}
            md={2}
            sm={3}
            xs={{ span: 4, offset: 1 }}
            style={{ paddingTop: '6px' }}
          >
            <Typography.Link onClick={() => setVisibleProduct((prevState) => !prevState)}>
              製品:
            </Typography.Link>
          </Col>
          <Col lg={3} md={4} sm={3} xs={7}>
            <Form.Item name={'productCd'}>
              <Input maxLength={15} onBlur={(e) => setProductCd(e.target.value)} />
            </Form.Item>
          </Col>
          <Col xl={4} md={4} sm={2} xs={11}>
            <Form.Item name={'productNm'}>
              <Input className="clsReadOnly" readOnly value={'製品名'} />
            </Form.Item>
          </Col>
        </Row>

        {/* 表示色調と生産拠点と検索ボタン */}
        <Row>
          <Col
            xxl={{ span: 1, offset: 6 }}
            xl={{ span: 2, offset: 8 }}
            lg={{ span: 2, offset: 9 }}
            md={{ span: 2, offset: 7 }}
            sm={{ span: 3, offset: 8 }}
            xs={{ span: 4, offset: 1 }}
            style={{ paddingTop: '6px' }}
          >
            <Typography.Link onClick={() => setVisibleColor((prevState) => !prevState)}>
              表示色調:
            </Typography.Link>
          </Col>
          <Col xl={4} md={3} sm={4} xs={18}>
            <Form.Item name={'color'}>
              <Input maxLength={20} />
            </Form.Item>
          </Col>
          <Col
            xxl={{ span: 1, offset: 1 }}
            md={{ span: 2, offset: 1 }}
            sm={{ span: 3, offset: 1 }}
            xs={{ span: 4, offset: 1 }}
          >
            <Form.Item label="生産拠点"></Form.Item>
          </Col>
          <Col xl={4} lg={4} sm={5} xs={18}>
            <Form.Item name={'prductHub'}>
              <Select allowClear notFoundContent=" ">
                {ktnList.length > 0 &&
                  ktnList.map((item, i) => {
                    return (
                      <Option key={i} value={item.ktn_cd}>
                        {item.ktn_nm}
                      </Option>
                    );
                  })}
              </Select>
            </Form.Item>
          </Col>

          {/* 検索ボタン・確定ボタン・クリアボタン */}
          <Col
            xxl={{ offset: 3 }}
            xl={{ offset: 18 }}
            lg={{ offset: 17 }}
            md={{ offset: 15 }}
            sm={{ offset: 13 }}
            xs={{ offset: 10 }}
            style={{ paddingTop: '6px' }}
          >
            <Space size={'large'}>
              <Button type="primary" onClick={clickBtSearch}>
                <SearchOutlined />
                検索
              </Button>
              <Button
                type="primary"
                style={{ display: visibleBtConf ? '' : 'none' }}
                onClick={clickBtConfi}
              >
                確定
              </Button>
              <Button type="primary" onClick={clickBtClear}>
                クリア
              </Button>
            </Space>
          </Col>
        </Row>
      </Form>
      {/* テーブル */}
      <Row style={{ paddingTop: '5vh', backgroundColor: '#e6f7ff' }}>
        <Col offset={1} xs={22}>
          <Form.Item name={'table'}>
            <JuchuShokaiTable
              searchList={searchList}
              rowIndex={rIdx}
              changeRowIndex={changeRowIndex}
              mCodeKaitoStatusList={mCodeKaitoStatusList}
              setSearchList={setSearchList}
              yobidashimotoKbn={props.yobidashimotoKbn}
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default forwardRef(JuchuShokai);
